/**
 * 维修产值统计
 */
import { REPAIRMONEYSTATISTICS } from '../types';

export default {
    name: `${REPAIRMONEYSTATISTICS}`,
    path: '/repairMoneyStatistics',
    component: () => import(/* webpackChunkName: 'repairMoneyStatistics' */ '@/views/repairMoneyStatistics/'),
    redirect: { name: `${REPAIRMONEYSTATISTICS}Index` },
    meta: {
        title: '维修产值统计',
        savedPosition: { x: 0, y: 0 },
        noCache: true,
    },
    children: [
        {
            name: `${REPAIRMONEYSTATISTICS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'repairMoneyStatistics' */ '@/views/repairMoneyStatistics/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${REPAIRMONEYSTATISTICS}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'repairMoneyStatistics' */ '@/views/repairMoneyStatistics/detail/Detail.vue'),
        // },
    ],
};
